export const OPEN_MODAL = 'SETTINGS/OPEN_API_KEY_MODAL';
export const CLOSE_MODAL = 'SETTINGS/CLOSE_API_KEY_MODAL';
export const SUBMIT_SUCCESS = 'SETTINGS/SUBMIT_API_KEY_SUCCESS';
